import { render, staticRenderFns } from "./SupportHeader.vue?vue&type=template&id=7f00b80e&scoped=true&"
import script from "./SupportHeader.vue?vue&type=script&lang=js&"
export * from "./SupportHeader.vue?vue&type=script&lang=js&"
import style0 from "./SupportHeader.vue?vue&type=style&index=0&id=7f00b80e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f00b80e",
  null
  
)

export default component.exports